import { Boton } from './ui';
import { esAppNativa, servidorEfectivo } from '../lib/servidor';

/**
 * Lo que se ve cuando hay sesión guardada pero no se pudo confirmar.
 *
 * ## Por qué no es la pantalla de login
 *
 * Porque no te sacaron: no hubo forma de preguntar. El token sigue guardado y
 * sano, y en cuanto vuelva la señal la sesión sigue en pie.
 *
 * Antes las dos cosas acababan en el formulario de login, así que una caída del
 * servidor se veía **igual** que «te cerramos la sesión»: el residente tecleaba
 * su contraseña, recibía un error de red que no explicaba nada, y concluía que
 * la app estaba rota. Distinguirlas no arregla la caída, pero convierte «esto
 * se descompuso» en «no hay señal», que es una respuesta con la que alguien
 * puede hacer algo.
 *
 * ## Lo que conviene decir aquí
 *
 * Que la reja **no** depende de esto. Un residente que ve su app caída se
 * pregunta si va a poder entrar a su casa, y la respuesta es que sí: la caseta
 * decide sola y no le pregunta nada a la nube.
 */
export function SinConexion({ alReintentar }: { alReintentar: () => void }) {
  return (
    <div className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-headline-md text-on-surface">Sin conexión</h1>

      <p className="text-body-md text-on-surface-variant">
        No se pudo hablar con el servidor. Tu sesión sigue abierta: en cuanto haya señal, todo
        vuelve como estaba.
      </p>

      {/* La tranquilidad primero, que es lo que de verdad se está preguntando
          quien mira esta pantalla. */}
      <p className="text-label-sm text-on-surface-variant">
        La entrada al fraccionamiento no depende de esto y sigue funcionando con normalidad.
      </p>

      <Boton onClick={alReintentar} className="w-full">
        Reintentar
      </Boton>

      {/* Solo en el APK: en el navegador no hay dirección que revisar, y saber
          contra qué servidor está fallando es lo primero que hace falta cuando
          alguien llama a preguntar. */}
      {esAppNativa() && (
        <p className="text-label-sm text-on-surface-variant opacity-70">
          Servidor: {servidorEfectivo() ?? 'sin elegir'}
        </p>
      )}
    </div>
  );
}
